const trimText = (value) => {
    if (typeof value !== "string") {
        return "";
    }
    return value.trim();
};

const isObject = (value) => value !== null && typeof value === "object" && !Array.isArray(value);

const extractProfile = (payload = {}) => {
    const data = payload && payload.data !== undefined
        ? payload.data
        : payload && payload.result;

    if (!isObject(data)) {
        return {};
    }

    if (isObject(data.result) &&
        data.nickname === undefined &&
        data.userName === undefined &&
        data.user_name === undefined) {
        return data.result;
    }

    return data;
};

const resolveProfileName = (profile = {}, fallback = "") => {
    const source = isObject(profile) ? profile : {};
    return [source.nickname, source.userName, source.user_name, fallback]
        .map(trimText)
        .find(Boolean) || "";
};

module.exports = {
    extractProfile,
    resolveProfileName,
};
